import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Icon } from "semantic-ui-react";
import Clipboard from "../../components/Clipboard";
import QrCodeHelper from "~/utils/QrCodeHelper";

export const getIframe = ({ title, url }) => {
  const urlObject = new URL(url);
  const baseUrl = `${urlObject.protocol}//${urlObject.hostname}`;

  return `<iframe title="${title}" width="854" height="640" border="0" frameborder="0" src="${url}" allowfullscreen="true" allow="camera ${baseUrl}; microphone ${baseUrl}"><a href="${url}" target="_top">View this tour in a new window.</a></iframe>`;
};

const LinkSection = observer(({ title, description, url, t }) => (
  <div className="tour-links-content-section">
    <h4>{title}</h4>
    {description ? <p>{description}</p> : null}
    <a href={url} target="_blank" rel="noopener noreferrer">
      {url}
    </a>
    {url && (
      <div className="tour-links-clipboard-wrap">
        <Clipboard data={url} animationTime={2000} contentPopup={t("copyURLClipboard")} circular />
        <Clipboard
          data={getIframe({ title, url })}
          animationTime={2000}
          contentPopup={t("copyIframeClipboard")}
          content={<Icon name="code" color="black" />}
        />
        <Button
          style={{ background: "none", marginTop: "-0.55em", marginLeft: "-0.2em" }}
          size="small"
          icon
          as="a"
          title={t("QR")}
          href={QrCodeHelper.makeQueryQrCode(url)}
          floated="right"
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="qrcode" color="black" />
        </Button>
      </div>
    )}
  </div>
));

LinkSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  url: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LinkSection);
